export class TrainingEligibilityForm {
    constructor(
        public learnerID: string = '',
        public learnerName: string = '',
        public emailID: string = '',
        public phoneNo: string = '',
        public postalCode: string = '',
        public trainingProgramId: string = '00000000-0000-0000-0000-000000000000',
        public eligibilityDate: Date = new Date(),
        public captchaToken: string = '') { }
}